<template>
  <div class="uk-width-3-4@s uk-text-left">
    <div class="uk-section uk-container uk-container-small">
      <h1 class="uk-margin-large-bottom f30">{{item.title}}</h1>
      <ul class="uk-margin-large-bottom uk-flex">
        <li v-for="category in item.categories" v-bind:key = category.id class="uk-margin-right">{{category}}</li>
      </ul>
      <div class="uk-margin-xlarge-bottom">
        <h2 class="subtitle uk-margin-bottom">練習方法</h2>
        {{item.how_to_training.text}}
        <img v-bind:src="item.how_to_training.img" alt="" class="single_img" />
      </div>
      <div class="uk-margin-xlarge-bottom">
        <h2 class="subtitle uk-margin-bottom">参考</h2>
        {{item.references.text}}
        <iframe width="" height="auto" v-bind:src="item.references.img" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="uk-width-2-3@s uk-width-1-1 uk-height-medium uk-margin-auto uk-display-block"></iframe>
      </div>
      <div class="uk-margin-xlarge-bottom">
        <h2 class="subtitle uk-margin-bottom">コツ・取得スキル</h2>
        {{item.other}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created () {
    const item = this.$store.getters.getItemById(this.$route.params.item_id)
    this.item = item
  },
  data() {
    return {
    }
  },
}
</script>

<style>
</style>